import count_unknown_digit from "./count_unknown_digit"

const calc_difficulty = (clue: string) => {
    const n = count_unknown_digit(clue)
    const max_unknown = 64 // need to make sure this is correct (hex)
    const percent_difficulty = (n / max_unknown) * 100
    return percent_difficulty
}

export default calc_difficulty